import { useCallback, useState } from "react";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
} from "recharts";

const UserChart = (props: { data: any[] | undefined; label: string }) => {
  const [width, setWidth] = useState<number | null>(null); // width of chart

  // ref to find apporpriate width of chart (responsive container demands width
  // in pixels which is not constant due to changing screen sizes. therefore,
  // we can use a ref to find the width of a div that scales with screen sizes,
  // and use that width for the responsive container)
  const ref = useCallback((current: HTMLDivElement) => {
    const resizeObserver = new ResizeObserver((event) => {
      const w = event[0].contentBoxSize[0].inlineSize;
      if (w) {
        setWidth(w);
      }
    });

    if (current) {
      resizeObserver.observe(current);
    }
  }, []);

  return (
    <>
      {props.data && props.data?.length > 0 && (
        <div
          className="flex flex-col items-center justify-center w-full"
          ref={ref}
        >
          <p className="text-3xl font-semibold text-indigo-500">
            {props.label}
          </p>
          <LineChart
            width={width ? width : 800}
            height={400}
            data={props.data.map((roundsData) => {
              let date = new Date(roundsData.timestamp);
              return {
                ...roundsData,
                date:
                  date.getMonth() +
                  1 +
                  "/" +
                  date.getDate() +
                  "/" +
                  date.getFullYear().toString().slice(2),
              };
            })}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis
              yAxisId="left"
              label={{ value: "Score & Accuracy", angle: -90, dx: -20 }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              label={{ value: "Precision", angle: 90, dx: 20 }}
              ticks={[0, 0.25, 0.5, 0.75, 1]}
            />
            <Tooltip />
            <Legend layout="horizontal" verticalAlign="top" align="center" />
            <Line
              type="monotone"
              dataKey="score"
              stroke="#06b6d4"
              strokeWidth={2}
              activeDot={{ r: 8 }}
              yAxisId="left"
            />
            <Line
              type="monotone"
              dataKey="precision"
              stroke="#a855f7"
              strokeWidth={2}
              activeDot={{ r: 8 }}
              yAxisId="right"
            />
            <Line
              type="monotone"
              dataKey="accuracy"
              stroke="#6366f1"
              strokeWidth={2}
              activeDot={{ r: 8 }}
              yAxisId="left"
            />
          </LineChart>
        </div>
      )}
    </>
  );
};

export default UserChart;
